import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingReportNoteView } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { NotesCard } from './NotesCard';

/** 做得好的 beside 可以更好的; either one alone takes the row. */
export const NotesSection = memo(
  ({
    strengths,
    missed,
  }: {
    strengths: CoachingReportNoteView[];
    missed: CoachingReportNoteView[];
  }) => {
    const { rpx } = useResponsiveContext();
    if (!strengths.length && !missed.length) return null;
    return (
      <View
        style={{ flexDirection: 'row', alignItems: 'stretch', gap: rpx(12) }}
      >
        {strengths.length ? (
          <NotesCard
            title="做得好的"
            notes={strengths}
            color={aiColors.accentForeground}
          />
        ) : null}
        {missed.length ? (
          <NotesCard title="可以更好的" notes={missed} color={aiColors.amber} />
        ) : null}
      </View>
    );
  },
);
